/** Libellés alignés avec le backend (PROFESSION_LABELS). */
export const PROFESSION_LABELS = {
  idel: 'Infirmier Libéral (IDEL)',
  mg: 'Médecin Généraliste',
  sf: 'Sage-Femme',
  kin: 'Kinésithérapeute',
  dent: 'Chirurgien-Dentiste',
  pharm: 'Pharmacien',
  as: 'Aide-Soignant',
  autre: 'Autre',
};
